import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { pickLang, t } from "../lib/i18n";
import { api } from "../lib/api";
import { ArrowUpRight } from "@phosphor-icons/react";

export default function Blog() {
  const { lang } = useLang();
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20" data-testid="blog-page">
      <div className="max-w-3xl">
        <div className="label-tag mb-4 slash">{t("sections.blog_eyebrow", lang)}</div>
        <h1 className="display-font text-5xl sm:text-7xl font-black uppercase leading-[0.9] tracking-tighter">
          {lang === "gr" ? <>Φωνές από <span className="neon-text">τα racks.</span></> : <>Field <span className="neon-text">notes.</span></>}
        </h1>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mt-16">
        {posts.map((p, i) => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="card-dark overflow-hidden group" data-testid={`blog-card-${i}`}>
            <div className="aspect-[16/9] overflow-hidden">
              <img src={p.cover_image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-6">
              <div className="flex flex-wrap gap-2 mb-3">
                {(p.tags || []).map((tag) => (
                  <span key={tag} className="mono-font text-[10px] uppercase tracking-[0.2em] text-[#ccff00] border border-[#ccff00]/40 px-2 py-1">{tag}</span>
                ))}
              </div>
              <h2 className="display-font text-2xl font-bold leading-tight">{pickLang(p.title, lang)}</h2>
              <p className="text-gray-400 mt-3 text-sm line-clamp-2">{pickLang(p.excerpt, lang)}</p>
              <div className="inline-flex items-center gap-1 mt-5 mono-font text-xs uppercase tracking-[0.2em] text-white group-hover:text-[#ccff00]">
                {lang === "gr" ? "Διαβάστε" : "Read"} <ArrowUpRight size={14} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
